import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";

export const getOffers = createAsyncThunk(
  "Offers/getOffers",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/restaurant/offers`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            lang: Cookies.get("zado_lng"),
            Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
          },
          params: data && data,
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getOfferstID = createAsyncThunk(
  "Offers/getOffersID",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/restaurant/offers/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            lang: Cookies.get("zado_lng"),
            Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const addOffers = createAsyncThunk(
  "Offers/addOffers",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/restaurant/offers`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            lang: Cookies.get("zado_lng"),
            Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const updateOffers = createAsyncThunk(
  "Offers/updateOffers",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/restaurant/offers/${data.id}/update`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            lang: Cookies.get("zado_lng"),
            Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const deleteOffers = createAsyncThunk(
  "Offers/deleteOffers",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.delete(
        `${process.env.REACT_APP_BACKEND_API}api/restaurant/offers/${id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            lang: Cookies.get("zado_lng"),
            Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getUsers = createAsyncThunk(
  "Offers/getUsers",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/restaurant/users`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            lang: Cookies.get("zado_lng"),
            Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
          },
          params: data && data,
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
const OffersSlice = createSlice({
  name: "Offers",
  initialState: {
    isOffersLoading: false,
    error: null,
    OffersArray: null,
    OfferID: null,
    Users: null,
  },
  extraReducers: (builder) => {
    builder
      // getOffers
      .addCase(getOffers.pending, (state) => {
        state.isOffersLoading = true;
      })
      .addCase(getOffers.fulfilled, (state, action) => {
        state.isOffersLoading = false;
        state.OffersArray = action.payload.data;
      })
      .addCase(getOffers.rejected, (state, action) => {
        state.isOffersLoading = false;
      })
      // getOfferstID

      .addCase(getOfferstID.pending, (state) => {
        state.isOffersLoading = true;
      })
      .addCase(getOfferstID.fulfilled, (state, action) => {
        state.isOffersLoading = false;
        state.OfferID = action.payload.data;
      })
      .addCase(getOfferstID.rejected, (state, action) => {
        state.isOffersLoading = false;
      })
      // addOffers
      .addCase(addOffers.pending, (state) => {
        state.isOffersLoading = true;
      })
      .addCase(addOffers.fulfilled, (state, action) => {
        state.isOffersLoading = false;
      })
      .addCase(addOffers.rejected, (state, action) => {
        state.isOffersLoading = false;
      })
      // updateOffers
      .addCase(updateOffers.pending, (state) => {
        state.isOffersLoading = true;
      })
      .addCase(updateOffers.fulfilled, (state, action) => {
        state.isOffersLoading = false;
      })
      .addCase(updateOffers.rejected, (state, action) => {
        state.isOffersLoading = false;
      })
      // deleteOffers
      .addCase(deleteOffers.pending, (state) => {
        state.isOffersLoading = true;
      })
      .addCase(deleteOffers.fulfilled, (state, action) => {
        state.isOffersLoading = false;
        state.OffersArray = state.OffersArray.filter(
          (ele) => ele.id !== action.meta.arg
        );
      })
      .addCase(deleteOffers.rejected, (state, action) => {
        state.isOffersLoading = false;
      })
      // getUsers
      .addCase(getUsers.pending, (state) => {
        state.isOffersLoading = true;
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        state.isOffersLoading = false;
        state.Users = action.payload.data;
      })
      .addCase(getUsers.rejected, (state, action) => {
        state.isOffersLoading = false;
      });
  },
});

export default OffersSlice.reducer;
